import { TableConfig } from "@/types";
import { DateUtils } from "@/helpers/DateUtils";

export const policyTableConfig: TableConfig = {
  body: [
    {
      id: "quoteNumber",
      title: "# cotización",
      source: "$record.custom_attributes.quote_number",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "policyNumber",
      title: "# póliza",
      source: "$record.custom_attributes.policy_number",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "createdAt",
      title: "Fecha de creación",
      source: "$record.created_at",
      component: "card-info-row",
      fallback: "-",
      formatter: (value) => (value ? DateUtils.formatDateTime({ date: value }) : "-"),
    },
    {
      id: "product",
      title: "Producto",
      source: "$record.process.name",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "applicantsName",
      title: "Nombre del cliente",
      source: "$record.applicants_name",
      component: "card-info-row",
      fallback: "-",
      formatter: (value) => (value ? String(value).toUpperCase() : "-"),
    },
    {
      id: "identificationType",
      title: "Tipo de identificación",
      source: "$record.custom_attributes.identification_type.detalle",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "identificationNumber",
      title: "Número de identificación",
      source: "$record.custom_attributes.identification_number",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "createdBy",
      title: "Usuario",
      source: "$record.created_by.name",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "quoteStatus",
      title: "Estado",
      source: "$record.grouped_tags.quote_status.0.name",
      component: "card-info-row",
      type: "vue-status-badge-v2",
      formatter: (value) => ({ label: value ?? "-", color: "color" }),
    },
  ],
  actions: [
    {
      id: "view",
      label: "Ver",
      classes: "btn btn-danger",
      icon: "eye",
      to: { name: "ReadPolicy", params: { id: "$record.id", stepId: "0001" } },
      conditions: [{ type: "can", values: [["applications-management.applications.read"]] }],
    },
  ],
};
